import React from "react";

function ScrollIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 24 43"
        >
            <path
                fill="#B083E0"
                d="M12 32A12 12 0 010 20v-8a12 12 0 1124 0v8a12 12 0 01-12 12zm0-30A10 10 0 002 12v8a10 10 0 0020 0v-8A10 10 0 0012 2zM11.998 42.41l-5.66-5.65a1 1 0 011.41-1.41l4.25 4.24 4.24-4.24a1 1 0 011.41 1.41l-5.65 5.65z"
            ></path>
            <path
                fill="#B083E0"
                d="M12 13a1 1 0 01-1-1V6a1 1 0 012 0v6a1 1 0 01-1 1z"
            ></path>
        </svg>
    );
}

export default ScrollIcon;
